import { render, staticRenderFns } from "./SlideTagMenu.vue?vue&type=template&id=016efdc6&scoped=true"
import script from "./SlideTagMenu.vue?vue&type=script&lang=ts"
export * from "./SlideTagMenu.vue?vue&type=script&lang=ts"
import style0 from "./SlideTagMenu.vue?vue&type=style&index=0&id=016efdc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016efdc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016efdc6')) {
      api.createRecord('016efdc6', component.options)
    } else {
      api.reload('016efdc6', component.options)
    }
    module.hot.accept("./SlideTagMenu.vue?vue&type=template&id=016efdc6&scoped=true", function () {
      api.rerender('016efdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SlideTagMenu.vue"
export default component.exports